import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from './containers/Home/Home';
import AddTestimonial from './containers/AddTestimonial/AddTestimonial';

class App extends Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route path='/'
              exact
              render={() => <Home />}
            />
            <Route path='/agregar-testimonio'
              exact
              render={() => <AddTestimonial />}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js